import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { StepsEnum, SubStepsEnum } from "layout/enums/step.enum";
import { Step } from "layout/models/step.model";

export const ReopenSteps: Step[] = [
	{
		id: StepsEnum.IDENTIFICAZIONE,
		icon: "fa-user-group",
		title: "Documenti LR",
		subtitle: "Allega i documenti",
		route: AppRouterService.get(PathEnum.reopenVerificaIdentitaLR),
		subSteps: [
			{
				id: SubStepsEnum.VERIFICA_IDENTITA,
				title: "Verifica identità",
				route: AppRouterService.get(PathEnum.reopenVerificaIdentitaLR),
			},
		],
		hideOnMenu: false,
	},
	{
		id: StepsEnum.IDENTIFICAZIONE,
		icon: "fa-user-group",
		title: "Documenti TE",
		subtitle: "Allega i documenti",
		route: AppRouterService.get(PathEnum.reopenVerificaIdentitaTE),
		subSteps: [
			{
				id: SubStepsEnum.VERIFICA_IDENTITA,
				title: "Verifica identità",
				route: AppRouterService.get(PathEnum.reopenVerificaIdentitaTE),
			},
		],
		hideOnMenu: false,
	},
	{
		id: StepsEnum.LA_TUA_AZIENDA,
		icon: "fa-shop",
		title: "Documenti Aziendali",
		subtitle: "Allega i documenti",
		route: AppRouterService.get(PathEnum.reopenDocumentiAziendali),
		subSteps: [
			{
				id: SubStepsEnum.DETTAGLI_SOCIETA,
				title: "Allega i documenti",
				route: AppRouterService.get(PathEnum.reopenDocumentiAziendali),
			},
		],
		hideOnMenu: false,
	},
	{
		id: StepsEnum.PAGAMENTI,
		icon: "fa-euro-sign",
		title: "Documenti Pagamenti",
		subtitle: "Allega i documenti",
		route: AppRouterService.get(PathEnum.reopenDocumentiPagamenti),
		subSteps: [
			{
				id: SubStepsEnum.MANDATO_ADDEBITO_DIRETTO,
				title: "Allega i documenti",
				route: AppRouterService.get(PathEnum.reopenDocumentiPagamenti),
			},
		],
		hideOnMenu: false,
	},
	{
		id: StepsEnum.VERIFICA_IDENTITA,
		icon: "fa-id-card",
		title: "Identificazione",
		subtitle: "Verifica la tua identità",
		route: AppRouterService.get(PathEnum.reopenIdentificazione),
		subSteps: [
			{
				id: SubStepsEnum.VERIFICA_IDENTITA,
				title: "Identificati",
				route: AppRouterService.get(PathEnum.reopenIdentificazione),
			},
		],
		hideOnMenu: false,
	},
	{
		id: StepsEnum.FIRMA_CONTRATTO,
		icon: "fa-file-signature",
		title: "Firma",
		subtitle: "Accettazione dei termini",
		route: AppRouterService.get(PathEnum.reopenFirma),
		subSteps: [
			{
				id: SubStepsEnum.FIRMA,
				title: "Firma",
				route: AppRouterService.get(PathEnum.reopenFirma),
			},
		],
		hideOnMenu: false,
	},
];
